module.exports = __webpack_public_path__ + "img/health19_7-9-2021.eb124b4a.jpg";